export const RESUME_CACHE_KEY = "resumeData";

// Resume text and job description saved on the landing page, picked up by the
// dashboard after sign-in.
export interface PendingResume {
  extractedLocalStorageText: string;
  localStorageJobDescription: string;
}

interface CacheRecord<T> {
  data: T;
  expiry: number;
}

// Small localStorage cache with a time-to-live.
export function setCache<T>(key: string, data: T, ttlMs: number): void {
  const record: CacheRecord<T> = { data, expiry: Date.now() + ttlMs };
  localStorage.setItem(key, JSON.stringify(record));
}

export function getCache<T>(key: string): CacheRecord<T> | null {
  const recordStr = localStorage.getItem(key);
  if (!recordStr) return null;

  try {
    const record = JSON.parse(recordStr) as CacheRecord<T>;
    if (Date.now() > record.expiry) {
      localStorage.removeItem(key);
      return null;
    }
    return record;
  } catch {
    localStorage.removeItem(key);
    return null;
  }
}

export function removeCache(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error(`Failed to remove cache for key "${key}":`, error);
  }
}
